<!--<template>-->
    <!--<div class="container">-->
        <!--<p>test</p>-->
    <!--</div>-->
<!--</template>-->
<template>
    <div>
        <navbar-header page-name="Сборка товара"/>
        <ListProducts class="body"></ListProducts>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import ListProducts from '@/components/ListProducts'
export default {
  name: 'ProductLayouts',
  data () {
    return {
    }
  },
  components: {
    ListProducts,
    NavbarHeader
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped>-->
    <!--.navbar-text {-->
        <!--padding: 0 10px;-->
    <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/views/ProductsLayout.vue